import { render, staticRenderFns } from "./my-page.component.vue?vue&type=template&id=1b0d63c7"
import script from "./my-page.component.js?vue&type=script&lang=js&external"
export * from "./my-page.component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports